"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAisleWeight = getAisleWeight;
async function getAisleWeight(machineRepo, aisleCode, machineId) {
    return await machineRepo.getAisleWeight(aisleCode, machineId);
}
